import { render, staticRenderFns } from "./BranchInformation.vue?vue&type=template&id=ab139d60"
import script from "./BranchInformation.vue?vue&type=script&lang=ts"
export * from "./BranchInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports